import React, { useState } from 'react';
import './Portfolio.css';
import {
  personalInfo,
  impactMetrics,
  skillTabsData,
  experiences,
  projects,
  blogPosts,
  enterpriseTraining,
  education,
} from './portfolioData';

import laptopIllustration from './easlo-laptop.svg';

function TabIcon({ id }) {
  switch (id) {
    case 'ai-agents':
      return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a4 4 0 0 0-4 4v1a4 4 0 0 0-3 3.87 4 4 0 0 0 2 3.46V16a4 4 0 0 0 5 3.87V22" />
          <path d="M12 2a4 4 0 0 1 4 4v1a4 4 0 0 1 3 3.87 4 4 0 0 1-2 3.46V16a4 4 0 0 1-5 3.87V22" />
          <line x1="8" y1="12" x2="16" y2="12" />
        </svg>
      );
    case 'eval-sdlc':
      return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      );
    case 'cloud-infra':
      return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
        </svg>
      );
    case 'languages-dbs':
      return (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      );
    default:
      return null;
  }
}

function SkillIcon({ type }) {
  switch (type) {
    case 'brain':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a4 4 0 0 0-4 4v1a4 4 0 0 0-3 3.87 4 4 0 0 0 2 3.46V16a4 4 0 0 0 5 3.87V22" />
          <path d="M12 2a4 4 0 0 1 4 4v1a4 4 0 0 1 3 3.87 4 4 0 0 1-2 3.46V16a4 4 0 0 1-5 3.87V22" />
          <line x1="8" y1="12" x2="16" y2="12" />
        </svg>
      );
    case 'graph':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="6" cy="6" r="3" />
          <circle cx="18" cy="6" r="3" />
          <circle cx="12" cy="18" r="3" />
          <line x1="8.5" y1="7.5" x2="15.5" y2="7.5" />
          <line x1="7.5" y1="8.5" x2="10.5" y2="15.5" />
          <line x1="16.5" y1="8.5" x2="13.5" y2="15.5" />
        </svg>
      );
    case 'bot':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="10" rx="2" />
          <circle cx="12" cy="5" r="2" />
          <path d="M12 7v4" />
          <line x1="8" y1="16" x2="8.01" y2="16" />
          <line x1="16" y1="16" x2="16.01" y2="16" />
        </svg>
      );
    case 'tool':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
        </svg>
      );
    case 'memory':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="4" width="16" height="16" rx="2" />
          <rect x="9" y="9" width="6" height="6" />
          <line x1="9" y1="1" x2="9" y2="4" />
          <line x1="15" y1="1" x2="15" y2="4" />
          <line x1="9" y1="20" x2="9" y2="23" />
          <line x1="15" y1="20" x2="15" y2="23" />
          <line x1="20" y1="9" x2="23" y2="9" />
          <line x1="20" y1="14" x2="23" y2="14" />
          <line x1="1" y1="9" x2="4" y2="9" />
          <line x1="1" y1="14" x2="4" y2="14" />
        </svg>
      );
    case 'shield':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      );
    case 'doc':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      );
    case 'branch':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <line x1="6" y1="3" x2="6" y2="15" />
          <circle cx="18" cy="6" r="3" />
          <circle cx="6" cy="18" r="3" />
          <path d="M18 9a9 9 0 0 1-9 9" />
        </svg>
      );
    case 'gauge':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      );
    case 'cloud':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
        </svg>
      );
    case 'server':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" ry="2" />
          <rect x="2" y="14" width="20" height="8" rx="2" ry="2" />
          <line x1="6" y1="6" x2="6.01" y2="6" />
          <line x1="6" y1="18" x2="6.01" y2="18" />
        </svg>
      );
    case 'database':
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <ellipse cx="12" cy="5" rx="9" ry="3" />
          <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
          <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
        </svg>
      );
    case 'code':
    default:
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6" />
          <polyline points="8 6 2 12 8 18" />
        </svg>
      );
  }
}

function FolderIcon() {
  return (
    <svg className="project-folder-svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
    </svg>
  );
}

function GitHubIcon({ style }) {
  return (
    <svg style={style} viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
      <path d="M12 2A10 10 0 0 0 2 12c0 4.42 2.87 8.17 6.84 9.5.5.08.66-.23.66-.5v-1.69c-2.77.6-3.36-1.34-3.36-1.34-.46-1.16-1.11-1.47-1.11-1.47-.91-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.87 1.52 2.34 1.07 2.91.83.1-.65.35-1.09.63-1.34-2.22-.25-4.55-1.11-4.55-4.92 0-1.11.38-2 1.03-2.71-.1-.25-.45-1.29.1-2.64 0 0 .84-.27 2.75 1.02.79-.22 1.65-.33 2.5-.33.85 0 1.71.11 2.5.33 1.91-1.29 2.75-1.02 2.75-1.02.55 1.35.2 2.39.1 2.64.65.71 1.03 1.6 1.03 2.71 0 3.82-2.34 4.66-4.57 4.91.36.31.69.92.69 1.85V21c0 .27.16.59.67.5C19.14 20.16 22 16.42 22 12A10 10 0 0 0 12 2z" />
    </svg>
  );
}

function TwitterXIcon({ style }) {
  return (
    <svg style={style} viewBox="0 0 24 24" width="13" height="13" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

function LinkedInIcon({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 24 24"
      width="14"
      height="14"
      fill="currentColor"
    >
      <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z" />
    </svg>
  );
}

function App() {
  const [activeSkillTab, setActiveSkillTab] = useState('ai-agents');
  const [expandedProjects, setExpandedProjects] = useState({});
  const [expandedExperience, setExpandedExperience] = useState({});

  const toggleProject = (projectId) => {
    setExpandedProjects((prev) => ({
      ...prev,
      [projectId]: !prev[projectId],
    }));
  };

  const toggleExperience = (expId) => {
    setExpandedExperience((prev) => ({
      ...prev,
      [expId]: !prev[expId],
    }));
  };

  const currentSkillCategory =
    (skillTabsData || []).find((tab) => tab.id === activeSkillTab) ||
    skillTabsData?.[0] || { id: 'ai-agents', label: 'AI & Agents', skills: [] };

  return (
    <div className="page-container">
      {/* 1. Minimal Navigation Bar */}
      <header className="site-nav">
        <div className="site-logo">
          <span>{personalInfo?.name || 'Raj Aryan'}</span>
          <span className="status-indicator">
            <span className="status-dot" />
            <span>Available for select roles</span>
          </span>
        </div>

        <nav className="nav-links">
          <a href="#skills">Skills</a>
          <a href="#experience">Experience</a>
          <a href="#projects">Projects</a>
          <a href="#writing">Writing</a>
          <a href="#education">Education</a>
          <a
            href={`mailto:${personalInfo?.email || 'rajaryan.ai@gmail.com'}`}
            style={{ fontWeight: 500, color: 'var(--text-primary)' }}
          >
            Contact
          </a>
        </nav>
      </header>

      {/* 2. Hero Section (Inspired by Easlo 2-Column Minimalist Hero) */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-tag">{personalInfo?.title || 'AI Agent, Cloud & Backend Engineer'}</div>
          <h1 className="hero-title">Hello, I'm {personalInfo?.name || 'Raj Aryan'}.</h1>

          <p className="hero-bio">
            {personalInfo.summary}
          </p>

          <div className="hero-actions">
            <a href={`mailto:${personalInfo?.email || 'rajaryan.rsr@gmail.com'}`} className="btn-primary">
              <span>Get in Touch</span>
              <span>→</span>
            </a>

            {personalInfo?.socials?.github && (
              <a
                href={personalInfo.socials.github}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                <GitHubIcon />
                <span>GitHub</span>
              </a>
            )}

            {personalInfo?.socials?.linkedin && (
              <a
                href={personalInfo.socials.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                <LinkedInIcon />
                <span>LinkedIn</span>
              </a>
            )}

            {personalInfo?.socials?.twitter && (
              <a
                href={personalInfo.socials.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary"
              >
                <TwitterXIcon />
                <span>Twitter / X</span>
              </a>
            )}
          </div>
        </div>

        <div className="hero-avatar-wrap">
          <div className="hero-avatar">
            <img src={laptopIllustration} alt={personalInfo?.name || 'Raj Aryan'} />
          </div>
        </div>
      </section>

      {/* 3. Impact Metrics Bar (a. AI Agent, b. Backend, c. Cloud, d. Training) */}
      {impactMetrics && impactMetrics.length > 0 && (
        <section className="metrics-section" aria-label="Key Impact Metrics">
          {impactMetrics.slice(0, 4).map((m, idx) => (
            <div key={m.id || idx} className="metric-card">
              {m.domain && <span className="metric-domain-tag">{m.domain}</span>}
              <div className="metric-val">{m.metric}</div>
              <div className="metric-label">{m.title}</div>
              <div className="metric-caption">{m.description}</div>
            </div>
          ))}
        </section>
      )}

      {/* 4. Skills Section (Tabbed, 3-column pill cards, strictly above Experience) */}
      <section id="skills" className="section skills-section">
        <div className="section-header">
          <h2 className="section-title">Skills</h2>
          <p className="section-desc">
            Core competencies, frameworks, and technologies in active production use.
          </p>
        </div>

        <div className="skills-toolbar">
          <div className="skills-tabs" role="tablist" aria-label="Skill categories">
            {skillTabsData.map((tab) => {
              const isActive = activeSkillTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  role="tab"
                  id={`tab-${tab.id}`}
                  aria-selected={isActive}
                  aria-controls={`panel-${tab.id}`}
                  className={`skill-tab-btn ${isActive ? 'active' : ''}`}
                  onClick={() => setActiveSkillTab(tab.id)}
                >
                  <span className="skill-tab-icon" aria-hidden="true">
                    <TabIcon id={tab.id} />
                  </span>
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div
          id={`panel-${currentSkillCategory.id}`}
          role="tabpanel"
          aria-labelledby={`tab-${currentSkillCategory.id}`}
          className="skills-cards-grid"
        >
          {(currentSkillCategory.skills || []).map((skill) => (
            <div key={skill.name} className="skill-card">
              <div className="skill-card-icon" aria-hidden="true">
                <SkillIcon type={skill.type} />
              </div>
              <span className="skill-card-name">{skill.name}</span>
            </div>
          ))}
        </div>
      </section>

      {/* 5. Experience Section (With Bullet Points, No Tables, No Forms) */}
      <section id="experience" className="section">
        <div className="section-header">
          <h2 className="section-title">Experience</h2>
          <p className="section-desc">Track record of building and scaling mission-critical AI systems.</p>
        </div>

        <div className="experience-list">
          {(experiences || []).map((exp, expIdx) => {
            const techList = exp.technologies || exp.techStack || [];
            const highlightList = exp.bullets || exp.highlights || [];
            const isExpExpanded = !!expandedExperience[exp.id];
            const visibleHighlights = isExpExpanded ? highlightList : highlightList.slice(0, 3);
            return (
              <article key={exp.id || exp.company || expIdx} className="experience-item">
                <div className="experience-header">
                  <div className="role-title">
                    {exp.role} <span className="company-name">@ {exp.company}</span>
                  </div>
                  <div className="experience-period">
                    {exp.period} · {exp.location}
                  </div>
                </div>

                {exp.summary && <p className="experience-summary">{exp.summary}</p>}

                {visibleHighlights.length > 0 && (
                  <ul className="experience-bullets">
                    {visibleHighlights.map((item, idx) => (
                      <li key={idx}>
                        {typeof item === 'string' ? (
                          item
                        ) : (
                          <>
                            {item.title && <strong>{item.title}: </strong>}
                            {item.description || item.text}
                            {item.impact && (
                              <span style={{ color: 'var(--text-primary)', fontWeight: 500 }}>
                                {' '}— {item.impact}
                              </span>
                            )}
                          </>
                        )}
                      </li>
                    ))}
                  </ul>
                )}

                {highlightList.length > 3 && (
                  <button
                    type="button"
                    className="btn-exp-more"
                    onClick={() => toggleExperience(exp.id)}
                    aria-expanded={isExpExpanded}
                  >
                    <span>
                      {isExpExpanded
                        ? 'Show fewer highlights ↑'
                        : `See all ${highlightList.length} highlights (${highlightList.length - 3} more) ↓`}
                    </span>
                  </button>
                )}

                {techList.length > 0 && (
                  <div className="tech-tag-row">
                    {techList.map((tech, tIdx) => (
                      <span key={typeof tech === 'string' ? tech : tIdx} className="tech-tag">
                        {typeof tech === 'string' ? tech : tech.name || tech}
                      </span>
                    ))}
                  </div>
                )}
              </article>
            );
          })}
        </div>
      </section>

      {/* 5. Projects Section (Matching Screenshot: Pill Tabs & Folder Cards) */}
      <section id="projects" className="section">
        <div className="section-header">
          <h2 className="section-title">Projects</h2>
        </div>

        <div className="projects-toolbar">
          <div className="projects-tabs" role="tablist" aria-label="Project categories">
            <button
              type="button"
              role="tab"
              aria-selected="true"
              className="project-tab-btn active"
            >
              <span className="project-tab-icon">★</span>
              <span>Featured</span>
            </button>

            {/* Past Projects tab commented out as requested */}
            {/*
            <button
              type="button"
              role="tab"
              className="project-tab-btn"
            >
              <span className="project-tab-icon">🕒</span>
              <span>Past Projects</span>
            </button>
            */}
          </div>
        </div>

        <div className="projects-grid">
          {(projects || []).map((p, pIdx) => {
            const techList = p.techStack || p.technologies || [];
            const projectId = p.id || `proj-${pIdx}`;
            const isExpanded = !!expandedProjects[projectId];
            // Short preview summary
            const shortText =
              p.tagline ||
              (p.description ? p.description.split('.')[0] + '.' : '');

            return (
              <article key={projectId} className="project-card">
                <div className="project-header-row" style={{ justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <FolderIcon />
                    <h3 className="project-title">{p.title}</h3>
                  </div>
                  {p.badge && (
                    <span className="project-badge-pill" style={{ marginTop: 0 }}>{p.badge}</span>
                  )}
                </div>

                <p className="project-desc">
                  {isExpanded ? p.description : shortText}
                </p>

                {p.impact && (
                  <div className="project-impact" style={{ marginBottom: '8px' }}>
                    <strong>Impact:</strong> {p.impact}
                  </div>
                )}

                {isExpanded && (
                  <div className="project-expanded-details">
                    {p.architecture && (
                      <p style={{ fontSize: '12.5px', color: 'var(--text-secondary)', lineHeight: 1.5, marginBottom: '8px' }}>
                        <strong style={{ color: 'var(--text-primary)' }}>Architecture: </strong>
                        {p.architecture}
                      </p>
                    )}
                    {p.highlights && p.highlights.length > 0 && (
                      <ul className="project-highlights-list">
                        {p.highlights.slice(0, 3).map((item, idx) => (
                          <li key={idx}>
                            {typeof item === 'string' ? item : item.description || item.title}
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* Tech chips only shown inside expanded view */}
                    {techList.length > 0 && (
                      <div className="tech-tag-row" style={{ marginTop: '10px' }}>
                        {techList.map((tech, tIdx) => (
                          <span key={typeof tech === 'string' ? tech : tIdx} className="tech-tag">
                            {typeof tech === 'string' ? tech : tech.name || tech}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                )}

                {/* Same row for See more and GitHub text button */}
                <div className="project-footer-row">
                  <button
                    type="button"
                    className="btn-text-action"
                    onClick={() => toggleProject(projectId)}
                    aria-expanded={isExpanded}
                  >
                    <span>{isExpanded ? 'Show less ↑' : 'See more ↓'}</span>
                  </button>

                  {p.repoUrl && (
                    <a
                      href={p.repoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-text-action"
                    >
                      <span>GitHub ↗</span>
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* 6. Technical Blog / Writing Section (Two Small Cards in Column Layout) */}
      <section id="writing" className="section">
        <div className="section-header">
          <h2 className="section-title">Writing &amp; Technical Deep Dives</h2>
          <p className="section-desc">Architectural insights on evaluation harnesses, agentic SDLC, and memory systems.</p>
        </div>

        <div className="blog-grid">
          {(blogPosts || []).map((post, bIdx) => {
            const CardTag = post.url ? 'a' : 'article';
            const cardProps = post.url
              ? {
                  href: post.url,
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  'aria-label': post.title,
                }
              : {};
            return (
              <CardTag
                key={post.id || post.title || bIdx}
                className="blog-card"
                {...cardProps}
              >
                <h3 className="blog-title">
                  <LinkedInIcon
                    style={{
                      width: 14,
                      height: 14,
                      display: 'inline-block',
                      verticalAlign: '-1.5px',
                      marginRight: '6px',
                      color: 'var(--accent-color)',
                    }}
                  />
                  <span>{post.title}</span>{' '}
                  <span className="blog-arrow">↗</span>
                </h3>

                <div className="blog-subtitle">
                  {post.category} · {post.readTime}
                </div>

                {post.excerpt && <p className="blog-excerpt">"{post.excerpt}"</p>}
              </CardTag>
            );
          })}
        </div>
      </section>

      {/* 8. Education & Enterprise Training (No Tables) */}
      <section id="education" className="section">
        <div className="section-header">
          <h2 className="section-title">Education &amp; Enterprise Enablement</h2>
          <p className="section-desc">Academic foundation and industry enablement across global engineering teams.</p>
        </div>

        <div className="education-list">
          {(education || []).map((edu, idx) => (
            <div key={edu.id || edu.institution || idx} className="education-card">
              <div>
                <div className="edu-institution">{edu.institution}</div>
                <div className="edu-degree">
                  {edu.degree?.includes('B.Tech') || edu.degree?.includes('Bachelor') ? (
                    <span className="metric-domain-tag" style={{ marginRight: '8px' }}>Undergraduate</span>
                  ) : edu.degree?.includes('XII') || edu.degree?.includes('12') || edu.degree?.includes('Higher Secondary') ? (
                    <span className="metric-domain-tag" style={{ marginRight: '8px' }}>Intermediate</span>
                  ) : null}
                  {edu.degree}
                  {edu.field ? ` (${edu.field})` : ''} · {edu.location}
                </div>
                {edu.honors && (
                  <div
                    className="edu-honors"
                    style={{ fontSize: '13px', color: 'var(--text-secondary)', marginTop: '4px' }}
                  >
                    {edu.honors}
                  </div>
                )}
              </div>
              {edu.score && <div className="edu-score">{edu.score}</div>}
            </div>
          ))}
        </div>

        {enterpriseTraining && (
          <div className="training-box">
            <h3 className="training-title">
              Enterprise AI Training ({enterpriseTraining.totalHours})
            </h3>
            <p className="training-desc">
              {enterpriseTraining.overview ||
                'Delivered 500+ hours of advanced Python, ML, LLM, Cloud (Kubernetes), and Backend engineering enablement across 10+ enterprise clients and engineering cohorts covering multi-agent architectures, RAG applications, and production evaluation.'}
            </p>

            {(enterpriseTraining.clients || []).length > 0 && (
              <div className="client-pills">
                {enterpriseTraining.clients.map((client, cIdx) => (
                  <span key={client.name || cIdx} className="client-pill">
                    {client.name}
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </section>

      {/* 9. Minimalist Footer */}
      <footer className="site-footer">
        <div>
          <span>{personalInfo?.name || 'Raj Aryan'}</span> ·{' '}
          <span>{personalInfo?.title || 'AI Agent, Cloud & Backend Engineer'}</span>
        </div>

        <div className="footer-links">
          {personalInfo?.socials?.github && (
            <a href={personalInfo.socials.github} target="_blank" rel="noopener noreferrer">
              GitHub
            </a>
          )}
          {personalInfo?.socials?.linkedin && (
            <a href={personalInfo.socials.linkedin} target="_blank" rel="noopener noreferrer">
              LinkedIn
            </a>
          )}
          {personalInfo?.socials?.twitter && (
            <a href={personalInfo.socials.twitter} target="_blank" rel="noopener noreferrer">
              Twitter / X
            </a>
          )}
          <a href={`mailto:${personalInfo?.email || 'rajaryan.rsr@gmail.com'}`}>Email</a>
        </div>
      </footer>
    </div>
  );
}

export default App;
